export enum ModalType {
  GDPR = 'gdpr',
  BIOMETRIC = 'biometric',
  TERMS = 'terms'
}
